// Test Suite — labels and small helpers shared by the views.

export const STATUS = {
  pass: { label: 'Bestanden', short: 'OK' },
  fail: { label: 'Abweichung', short: 'Fehler' },
  flaky: { label: 'Schwankend (nicht jeder Versuch richtig)', short: '±' },
  error: { label: 'Technischer Fehler', short: 'Error' },
  skipped: { label: 'Nicht bewertet', short: '—' },
  running: { label: 'Läuft', short: '…' },
  none: { label: 'Noch nicht getestet', short: '' },
};

export const ASSISTANT = { efd: 'Bro EFD', ppi: 'Bro PPI' };
export const VARIANT = { mh: 'Standard (MH)', efd_survista: 'survista', ppi: 'PPI' };
export const SCOPE = { all: 'Gesamtbuch', advisor: 'Berater', consolidation: 'Konsolidierung', portfolio: 'Portfolio' };
export const VARIANTS_OF = { efd: ['mh', 'efd_survista'], ppi: ['ppi'] };

export const CHECK_TYPES = [
  { key: 'value', label: 'Wert', hint: 'Eine Zahl muss in der Antwort stehen — live aus dem Dashboard oder fest.' },
  { key: 'contains', label: 'Text kommt vor', hint: 'Mindestens einer der Texte muss vorkommen.' },
  { key: 'not_contains', label: 'Text kommt nicht vor', hint: 'Keiner der Texte darf vorkommen.' },
  { key: 'order', label: 'Reihenfolge', hint: 'Die Namen müssen in dieser Reihenfolge erscheinen.' },
  { key: 'refusal', label: 'Muss ablehnen', hint: 'Bro muss sagen, dass er das nicht sehen darf.' },
  { key: 'period', label: 'Stand genannt', hint: 'Die Antwort nennt den Stichtag der Daten.' },
  { key: 'tool', label: 'Werkzeug benutzt', hint: 'Bro muss dieses Werkzeug (und diese Ansicht) benutzt haben.' },
];
export const CHECK_LABEL = Object.fromEntries(CHECK_TYPES.map((c) => [c.key, c.label]));

/** Combined status of several attempts of one question for one profile. */
export function combine(results) {
  if (!results || !results.length) return { status: 'none', passed: 0, total: 0 };
  const total = results.length;
  const passed = results.filter((r) => r.status === 'pass').length;
  const order = ['error', 'fail', 'skipped', 'pass'];
  const status = order.find((s) => results.some((r) => r.status === s)) || 'none';
  return { status: status === 'fail' && passed > 0 ? 'flaky' : status, passed, total };
}

export function applies(c, p) {
  if (c.assistant !== p.assistant) return false;
  const v = c.variants || []; const s = c.scope_types || []; const d = c.data_sets || [];
  return (!v.length || v.includes(p.variant)) && (!s.length || s.includes(p.scope_type))
    && (!d.length || d.includes(p.data_source_key));
}

export const num = (v) => {
  if (v === null || v === undefined || v === '') return '—';
  const n = Number(v);
  if (!Number.isFinite(n)) return String(v);
  const digits = Math.abs(n) >= 1000 || Number.isInteger(n) ? (Number.isInteger(n) ? 0 : 2) : 2;
  return n.toLocaleString('de-CH', { minimumFractionDigits: digits === 2 && !Number.isInteger(n) ? 1 : 0,
    maximumFractionDigits: digits });
};

export function when(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleString('de-CH', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function seconds(ms) {
  if (!ms && ms !== 0) return '';
  return ms < 60000 ? `${Math.round(ms / 1000)} s` : `${Math.floor(ms / 60000)} min ${Math.round((ms % 60000) / 1000)} s`;
}

export const expectedText = (check) => {
  const e = check.expected;
  if (Array.isArray(e)) return e.map((x) => (typeof x === 'number' ? num(x) : `„${x}“`)).join(', ');
  return typeof e === 'number' ? num(e) : (e ?? '—');
};

export const lines = (text) => String(text || '').split(/\n|;/).map((s) => s.trim()).filter(Boolean);

export const blankCase = (assistant = 'efd') => ({
  assistant, variants: [], scope_types: [], data_sets: [], question: '', language: 'de',
  checks: [{ type: 'value', label: '', metric: '', expected: '', valid_for: '' }], origin: '', notes: '', active: true,
});
